import service from '@/services/superaccess'

const support = {
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    getProperties (context) {
      return service.get('/api/properties/all', context)
    },
    retrieveSites (context, payload) {
      return service.post('/api/sync/all_sites', context, payload)
    },
    retrievePendings (context, payload) {
      return service.post('/api/sync/sync_control', context, payload)
    }
  }
}

export default support



// WEBPACK FOOTER //
// app/javascript/src/store/support.js